import { Link } from '@heroui/link';
import Icon from '@/components/Common/Icons/Icon';
import { NextUI } from '@/components/NextUI';
import React from 'react';
import { showSide } from '@/store/slices/sideSlice';
import { useAppDispatch } from '@/hooks/redux';
import { useTranslations } from 'next-intl';
import {
  logHubxEvent,
  APP_EVENTS,
  COMMON_EVENTS,
} from '@/lib/analytics/services/log-hubx-event';
import usePaddlePricing from '@/features/subscription/hooks/usePaddlePricing';
import { getPrimaryPrice } from '@/helpers/pricing-helper';
import { setTypeForUserAccessLevel } from '@/store/slices/userAccessSlice';

const UnauthenticatedMenu = ({
  openSide,
}: {
  openSide: (sideKey: string) => void;
}) => {
  const dispatch = useAppDispatch();
  const t = useTranslations('navbar');
  const { yearlyPrices, monthlyPrices, weeklyPrices } = usePaddlePricing();

  return (
    <>
      {/* <NextUI.Button
        className="!w-[352px] !min-h-12"
        onClick={() => {
          dispatch(
            showSide({
              sideKey: 'register',
              sideData: { openPaywall: false },
            })
          );
          logHubxEvent({ eventName: APP_EVENTS.BTN_HEADER_FREE_TRIAL });
          dispatch(setTypeForUserAccessLevel('header_free_trial'));
          const primaryPrice = getPrimaryPrice({
            yearlyPrices,
            monthlyPrices,
            weeklyPrices,
          });

          logHubxEvent({
            eventName: COMMON_EVENTS.PURCHASE_BUTTON_CLICK,
            event_params: {
              paywallType: 'header_free_trial',
              currency: primaryPrice?.unit_price?.currency_code,
              amount: (primaryPrice?.unit_price?.amount ?? 0) / 100,
              product_id: primaryPrice?.product_id!,
            },
          });
        }}
      >
        {t('free_trial')}
      </NextUI.Button> */}
      <div
        className="flex items-center gap-2 cursor-pointer"
        onClick={() => {
          openSide('login');
          logHubxEvent({ eventName: APP_EVENTS.BTN_HEADER_LOGIN });
        }}
      >
        <Icon name="UserIcon" width={16} />
        <span>{t('login')}</span>
      </div>
      {/* <div>
        <Link
          href="/pricing"
          className="text-[17px] font-normal text-gray-dark"
          onClick={() => {
            logHubxEvent({ eventName: APP_EVENTS.BTN_HEADER_PRICING });
            dispatch(setTypeForUserAccessLevel('header_free_trial'));
            logHubxEvent({
              eventName: COMMON_EVENTS.PURCHASE_BUTTON_CLICK,
              event_params: {
                paywallType: 'header_free_trial',
                currency: yearlyPrices[0]?.unit_price?.currency_code,
                amount: yearlyPrices[0].unit_price.amount / 100,
                product_id: yearlyPrices[0]?.product_id!,
              },
            });
          }}
        >
          {t('pricing')}
        </Link>
      </div> */}
      <div>
        <Link href="/blog" className="text-[17px] font-normal text-gray-dark">
          {t('blog')}
        </Link>
      </div>
      <div>
        <Link href="/faq" className="text-[17px] font-normal text-gray-dark">
          {t('faq')}
        </Link>
      </div>
    </>
  );
};

export default UnauthenticatedMenu;
